module.exports = __webpack_public_path__ + "media/back.5e94467d.flac";